import { usePress } from '@react-aria/interactions';
import { useMenuTrigger } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';
import { useEffect, useState } from 'react';
export const useMenu = ({ disabledKeys, onAction, triggerRef }) => {
    const [anchorPoint, setAnchorPoint] = useState();
    const menuTriggerState = useMenuTriggerState({});
    const { menuProps, menuTriggerProps } = useMenuTrigger({}, menuTriggerState, triggerRef);
    const { pressProps } = usePress(menuTriggerProps);
    useEffect(() => {
        if (anchorPoint !== undefined && !menuTriggerState.isOpen) {
            setAnchorPoint(undefined);
        }
    }, [anchorPoint, menuTriggerState.isOpen]);
    return {
        isOpen: menuTriggerState.isOpen,
        menuProps: {
            ...menuProps,
            anchorPoint,
            disabledKeys,
            onAction,
            onClose: menuProps.onClose,
            triggerRef,
        },
        openAsContextMenu: (event) => {
            event.preventDefault();
            setAnchorPoint({ x: event.clientX, y: event.clientY });
            menuTriggerState.open();
        },
        triggerProps: pressProps,
    };
};
//# sourceMappingURL=useMenu.js.map